import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="placeholder-override"
export default class extends Controller {
  connect() {
    this.placeholderValue = this.element.getAttribute("placeholder");
    this.element.dataset.action = `blur->${this.identifier}#blur focus->${this.identifier}#focus`;
  }

  focus() {
    if (this.element.value == "") {
      this.element.value = this.placeholderValue;
    }
  }

  blur() {
    if (this.element.value == this.placeholderValue) {
      this.element.value = "";
    }
  }
}
